import axios from "axios";
import React, { Component, useState, useEffect, useContext } from 'react';
import queryString from 'query-string';
import Swal from 'sweetalert2';
import { Cookies } from '../../index.js';
import { useNavigate } from 'react-router-dom';
import { alert_error, alert_success } from '../../AppContext';
import { ClipLoader } from 'react-spinners';
function Setcookie() {

  const [buttonTextjop, setButtonTextjop] = useState("checktim");
  const [lienketjop, setLienketjop] = useState('');

  // Gọi hàm alert_error

  const [lienket, setLienket] = useState('');
  const [idlink, setidlink] = useState('');
  const [taskId, settaskId] = useState('');
  const [loading, setLoading] = useState(false);
  const [api_key, setapi_key] = useState('');
  const [lienketok, setlienketok] = useState('');
  const [code3, setcode3] = useState('');
  const navigate = useNavigate();
  function laydulieu() {

  };
  function check() {
    const hustmediavipro = Cookies.get('hustmediavipro');
    if (hustmediavipro && hustmediavipro.length > 4) {
      const urlParams = new URLSearchParams(window.location.search);
      const lienket = urlParams.get('lienket');
      Cookies.set('hustmediavipro', lienket, { expires: 1 / 12 });
      setTimeout(() => {
        navigate('/home2/');
      }, 500);
    }
    else {
      const urlParams = new URLSearchParams(window.location.search);
      const lienket = urlParams.get('lienket');
      Cookies.set('hustmediavipro', lienket, { expires: 1 / 12 });
      setTimeout(() => {
        navigate('/home2/');
      }, 500);
    }
  };
  useEffect(() => {
    // setLoading(true);
    // const fetchLienketjop = async () => {
    //     try {
    //       const response = await axios.get('https://hust.media/jop/getjopurl.php');
    //       setLienketjop(response.data.urlok);
    //       setidlink(response.data.idlink);
    //       settaskId(response.data.taskId);
    //       setcode3(response.data.code3);
    //       demview();
    //     } catch (error) {
    //       alert_error('Lỗi xảy ra vui lòng load lại');
    //     }

    //   };


    //   fetchLienketjop();
    check();




  }, []);
  const demview = async () => {
    const values = queryString.parse(window.location.search);
    setLienket(values.lienket);
    const valueslienket = values.lienket
    try {
      const response = await axios.get('https://hust.media/link/load_system/checkinfo.php?lienket=' + valueslienket);
      if (response.data.status == 0) {
        alert_error(response.data.error);
        window.open('https://hust.media', '_blank');
      }
      else if (response.data.status == 1) {
        alert_success('Lấy dữ liệu liên kết thành công');
        setapi_key(response.data.api_key);
        setlienketok(response.data.url);
        console.log(response.data.url);
      }

    } catch (error) {

    }
    setLoading(false);
  };



  return (

    <div className="max-w-2xl px-1 py-4  mx-auto rounded-lg shadow-xl">
      <div className="container-fluid">
        <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center ">

          <ClipLoader color="#fff" size={150} />
        </div></div>
    </div>
  );

}

export default Setcookie;
